import { useEffect, useRef } from "react";

/**
 * Provides a ref that will automatically scroll into the middle of the viewport
 * (smoothly) whenever the associated drawer becomes open.
 *
 */
export function useScrollDrawerIntoView<T extends HTMLElement = HTMLDivElement>(
  open: boolean,
) {
  const ref = useRef<T | null>(null);

  useEffect(() => {
    if (open && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [open]);

  return ref;
}
